import { IfcSchedulingTime } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesIfc from "./entity_types_ifc.gen.js";
///**
// * http://www.buildingsmart-tech.org/ifc/ifc4/final/html/link/ifcresourcetime.htm */
export class IfcResourceTime extends IfcSchedulingTime {
    get type() {
        return EntityTypesIfc.IFCRESOURCETIME;
    }
    get ScheduleWork() {
        if (this.ScheduleWork_ === void 0) {
            this.ScheduleWork_ = this.extractString(3, true);
        }
        return this.ScheduleWork_;
    }
    get ScheduleUsage() {
        if (this.ScheduleUsage_ === void 0) {
            this.ScheduleUsage_ = this.extractNumber(4, true);
        }
        return this.ScheduleUsage_;
    }
    get ScheduleStart() {
        if (this.ScheduleStart_ === void 0) {
            this.ScheduleStart_ = this.extractString(5, true);
        }
        return this.ScheduleStart_;
    }
    get ScheduleFinish() {
        if (this.ScheduleFinish_ === void 0) {
            this.ScheduleFinish_ = this.extractString(6, true);
        }
        return this.ScheduleFinish_;
    }
    get ScheduleContour() {
        if (this.ScheduleContour_ === void 0) {
            this.ScheduleContour_ = this.extractString(7, true);
        }
        return this.ScheduleContour_;
    }
    get LevelingDelay() {
        if (this.LevelingDelay_ === void 0) {
            this.LevelingDelay_ = this.extractString(8, true);
        }
        return this.LevelingDelay_;
    }
    get IsOverAllocated() {
        if (this.IsOverAllocated_ === void 0) {
            this.IsOverAllocated_ = this.extractBoolean(9, true);
        }
        return this.IsOverAllocated_;
    }
    get StatusTime() {
        if (this.StatusTime_ === void 0) {
            this.StatusTime_ = this.extractString(10, true);
        }
        return this.StatusTime_;
    }
    get ActualWork() {
        if (this.ActualWork_ === void 0) {
            this.ActualWork_ = this.extractString(11, true);
        }
        return this.ActualWork_;
    }
    get ActualUsage() {
        if (this.ActualUsage_ === void 0) {
            this.ActualUsage_ = this.extractNumber(12, true);
        }
        return this.ActualUsage_;
    }
    get ActualStart() {
        if (this.ActualStart_ === void 0) {
            this.ActualStart_ = this.extractString(13, true);
        }
        return this.ActualStart_;
    }
    get ActualFinish() {
        if (this.ActualFinish_ === void 0) {
            this.ActualFinish_ = this.extractString(14, true);
        }
        return this.ActualFinish_;
    }
    get RemainingWork() {
        if (this.RemainingWork_ === void 0) {
            this.RemainingWork_ = this.extractString(15, true);
        }
        return this.RemainingWork_;
    }
    get RemainingUsage() {
        if (this.RemainingUsage_ === void 0) {
            this.RemainingUsage_ = this.extractNumber(16, true);
        }
        return this.RemainingUsage_;
    }
    get Completion() {
        if (this.Completion_ === void 0) {
            this.Completion_ = this.extractNumber(17, true);
        }
        return this.Completion_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
IfcResourceTime.query = [EntityTypesIfc.IFCRESOURCETIME];
IfcResourceTime.expectedType = EntityTypesIfc.IFCRESOURCETIME;
